export interface PlanningMaterialStatus {
  id: number;
  label: string;
}

export const materialStatusList: PlanningMaterialStatus[] = [
  { id: 1, label: 'Received' },
  { id: 2, label: 'On MWR' },
  { id: 3, label: 'Issued' },
];
